import * as Sentry from "@sentry/react"
import type { TokenUser } from "@/types/api"

let initialized = false

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN
  if (!dsn || initialized) return

  Sentry.init({
    dsn,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || "development",
    tracesSampleRate: import.meta.env.DEV ? 1.0 : 0.1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
  })

  initialized = true
}

export function setSentryUser(user: TokenUser) {
  Sentry.setUser({
    id: String(user.id),
    email: user.email,
    username: user.username,
  })
}

export function clearSentryUser() {
  Sentry.setUser(null)
}

export function captureError(
  error: unknown,
  context?: Record<string, unknown>,
) {
  Sentry.captureException(error, { extra: context })
}
